const isBrowser = !!window?.document?.createElement;

export default isBrowser;
